'use strict';

module.exports = text;
var u = require('unist-builder');
function text(h, node) {
  return h.augment(node, u('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1')));
}